// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/quickAccess/portal-da-transparencia.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/img/quickAccess/portal-da-transparencia-.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/img/quickAccess/acesso-cidadao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/img/quickAccess/acesso-cidadao-.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/img/quickAccess/lei-geral-de-acesso-informacao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/img/quickAccess/lei-geral-de-acesso-informacao-.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/img/quickAccess/diario-oficial.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/img/quickAccess/diario-oficial-.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/img/quickAccess/legislacao-estadual.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../assets/img/quickAccess/legislacao-estadual-.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../assets/img/quickAccess/acoes-de-governo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../assets/img/quickAccess/acoes-de-governo-.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#transparentCeara {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat #fff;
}

i#transparentCeara:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

#serviceLetter {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat #fff;
}

i#serviceLetter:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

#ldpg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center center no-repeat #fff;
}

i#ldpg:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

#officialDiary {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) center center no-repeat #fff;
}

i#officialDiary:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

#staleLaw {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) center center no-repeat #fff;
}

i#staleLaw:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

#governmentActions {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) center center no-repeat #fff;
}

i#governmentActions:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center bottom 15px no-repeat #00a84a;
  background-size: 50px !important;
}

.quick-access {
  background-color: #e9e9e9;
  padding-bottom: 40px;
}
.quick-access h4 {
  margin: 25px 0 20px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 2;
  font-weight: 900;
}
.quick-access .quick-access-links {
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
}
.quick-access .quick-access-links li:hover i:after {
  height: 80px;
  transition: height 0.2s ease-in-out;
}
.quick-access .quick-access-links li:first-child {
  margin-left: 0;
}
.quick-access .quick-access-links li:last-child {
  margin-right: 0;
}
.quick-access .quick-access-links li {
  margin: 0 25px;
  width: 16.4%;
  list-style: none;
  text-align: center;
}
.quick-access .quick-access-links li a {
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #000;
  text-decoration: none;
  outline: none !important;
  font-weight: 900;
  font-size: 0.9em;
}
.quick-access .quick-access-links li a i {
  background-size: 50px !important;
  margin-bottom: 10px;
  position: relative;
  display: block;
  width: 100%;
  height: 80px;
}
.quick-access .quick-access-links li a i:after {
  position: absolute;
  display: block;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #00a84a;
  content: "";
  transition: height 0.2s ease-in-out;
}

@media (max-width: 1025px) {
  .quick-access-links {
    flex-wrap: wrap;
  }
  .quick-access-links li {
    margin: 0 12px 20px !important;
    width: calc(33% - 24px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/QuickAccess/quickAccess.scss"],"names":[],"mappings":"AAAA;EACE,gFAAA;AACF;;AAGA;EACE,wFAAA;EAEA,gCAAA;AADF;;AAIA;EACE,gFAAA;AADF;;AAKA;EACE,wFAAA;EAEA,gCAAA;AAHF;;AAMA;EACE,gFAAA;AAHF;;AAOA;EACE,wFAAA;EAEA,gCAAA;AALF;;AAQA;EACE,gFAAA;AALF;;AASA;EACE,wFAAA;EAEA,gCAAA;AAPF;;AAUA;EACE,gFAAA;AAPF;;AAWA;EACE,wFAAA;EAEA,gCAAA;AATF;;AAYA;EACE,iFAAA;AATF;;AAaA;EACE,yFAAA;EAEA,gCAAA;AAXF;;AAcA;EACE,yBAAA;EACA,oBAAA;AAXF;AAYE;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;AAYE;EACE,aAAA;EACA,oBAAA;EACA,qBAAA;AAVJ;AAWI;EACE,YAAA;EAEA,mCAAA;AATN;AAWI;EACE,cAAA;AATN;AAWI;EACE,eAAA;AATN;AAWI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AATN;AAUM;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AARR;AASQ;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAPV;AASQ;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EAEA,mCAAA;AAPV;;AAcA;EACE;IACE,eAAA;EAXF;EAYE;IACE,8BAAA;IACA,kCAAA;EAVJ;AACF","sourcesContent":["#transparentCeara {\n  background: url(../../../assets/img/quickAccess/portal-da-transparencia.svg)\n    center center no-repeat #fff;\n}\n\ni#transparentCeara:after {\n  background: url(../../../assets/img/quickAccess/portal-da-transparencia-.svg)\n    center bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n#serviceLetter {\n  background: url(../../../assets/img/quickAccess/acesso-cidadao.svg) center\n    center no-repeat #fff;\n}\n\ni#serviceLetter:after {\n  background: url(../../../assets/img/quickAccess/acesso-cidadao-.svg) center\n    bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n#ldpg {\n  background: url(../../../assets/img/quickAccess/lei-geral-de-acesso-informacao.svg)\n    center center no-repeat #fff;\n}\n\ni#ldpg:after {\n  background: url(../../../assets/img/quickAccess/lei-geral-de-acesso-informacao-.svg)\n    center bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n#officialDiary {\n  background: url(../../../assets/img/quickAccess/diario-oficial.svg) center\n    center no-repeat #fff;\n}\n\ni#officialDiary:after {\n  background: url(../../../assets/img/quickAccess/diario-oficial-.svg) center\n    bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n#staleLaw {\n  background: url(../../../assets/img/quickAccess/legislacao-estadual.svg)\n    center center no-repeat #fff;\n}\n\ni#staleLaw:after {\n  background: url(../../../assets/img/quickAccess/legislacao-estadual-.svg)\n    center bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n#governmentActions {\n  background: url(../../../assets/img/quickAccess/acoes-de-governo.svg) center\n    center no-repeat #fff;\n}\n\ni#governmentActions:after {\n  background: url(../../../assets/img/quickAccess/acoes-de-governo-.svg) center\n    bottom 15px no-repeat #00a84a;\n  background-size: 50px !important;\n}\n\n.quick-access {\n  background-color: #e9e9e9;\n  padding-bottom: 40px;\n  h4 {\n    margin: 25px 0 20px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    line-height: 2;\n    font-weight: 900;\n  }\n  .quick-access-links {\n    display: flex;\n    margin: 0 !important;\n    padding: 0 !important;\n    li:hover i:after {\n      height: 80px;\n      -webkit-transition: height 0.2s ease-in-out;\n      transition: height 0.2s ease-in-out;\n    }\n    li:first-child {\n      margin-left: 0;\n    }\n    li:last-child {\n      margin-right: 0;\n    }\n    li {\n      margin: 0 25px;\n      width: 16.4%;\n      list-style: none;\n      text-align: center;\n      a {\n        letter-spacing: 0.5px;\n        text-transform: uppercase;\n        color: #000;\n        text-decoration: none;\n        outline: none !important;\n        font-weight: 900;\n        font-size: 0.9em;\n        i {\n          background-size: 50px !important;\n          margin-bottom: 10px;\n          position: relative;\n          display: block;\n          width: 100%;\n          height: 80px;\n        }\n        i:after {\n          position: absolute;\n          display: block;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 4px;\n          background-color: #00a84a;\n          content: '';\n          -webkit-transition: height 0.2s ease-in-out;\n          transition: height 0.2s ease-in-out;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1025px) {\n  .quick-access-links {\n    flex-wrap: wrap;\n    li {\n      margin: 0 12px 20px !important;\n      width: calc(33% - 24px) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
